/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import fs from 'fs'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};
const PreCode = makeShortcode("PreCode");
const ExternalLink = makeShortcode("ExternalLink");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <section>
  <PreCode code={fs.readFileSync(__dirname + '/legacy2.ts')} mdxType="PreCode" />
    </section>
    <section>
  <div className="fragment fade-out error">Why? Any difference????</div>
  <div className="fragment fade-in">
    <span className="warn">My original understanding:</span>
    <p className="fragment fade-in">
      Maybe <code>type</code> is more specific than <code>interface</code>.
    </p>
    <p className="fragment fade-in">But then I find out it could be a bug</p>
  </div>
    </section>
    <section style={{
      bottom: 0,
      overflow: 'auto'
    }}>
  <div className="fragment fade-in">
    <img src="https://i.stack.imgur.com/6Tjyp.png" alt="Difference" />
  </div>
    </section>
    <section>
  <ExternalLink href="https://stackoverflow.com/questions/37233735/typescript-interfaces-vs-types" mdxType="ExternalLink">
    Reference
  </ExternalLink>
  <br />
  <ExternalLink href="https://github.com/microsoft/TypeScript/issues/15300" mdxType="ExternalLink">
    Related Issue
  </ExternalLink>
    </section>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
